'use client'

import useOusideClick from "@/hooks/useQusideClick";
import { atom, useAtomValue, useSetAtom } from "jotai";
import { PropsWithChildren, useRef } from "react";

export const PannelVisible = atom(false);
export const ShowItemIndex = atom<number | null>(null);

export function Pannel(
    props: PropsWithChildren<{
      className?: string;
    }>
  ) {
    const visible = useAtomValue(PannelVisible);
    const setShowIndex = useSetAtom(ShowItemIndex);
    const setShow = useSetAtom(PannelVisible);
    const panelRef = useRef(null);
    // useOusideClick(
    //   panelRef,
    //   () => {
    //     setShow(false);
    //     setShowIndex(null);
    //   },
    //   []
    // )
    return <div
      {...props}
      ref={panelRef}
      data-state={visible ? "open" : "closed"}
    >{props.children}</div>;
  }
  